import React from "react";
import BaseInput from "../../../../components/BaseInput";
import { useTranslation } from "react-i18next";
import BaseFormBlock from "../BaseFormBlock";
import "./style.scss";
import PropTypes from "prop-types";
import AnswerTitle from "../../../InsightQuestionnaireFormPage/components/AnswerTitle";
import BaseTextArea from "../../../../components/BaseTextArea";

export default function TextAnswer({ title, name, number, question }) {
  TextAnswer.propTypes = {
    number: PropTypes.number.isRequired,
    title: PropTypes.string.isRequired,
    name: PropTypes.string.isRequired,
    value: PropTypes.string.isRequired,
  };
  const { t } = useTranslation();

  return (
    <BaseFormBlock>
      <div className="insight-text-answer-both">
        <AnswerTitle title={title} number={number} />
        {question.userAnswer?.value ? (
          <div className="insight-text-answer-both__input-wrapper">
            <div className="insight-text-answer-both__label">
              {t("insight_questionnaire_form_page.myAnswer")}
            </div>
            <div placeholder={t("insight_questionnaire_form_page.myAnswer")}>
              {question.userAnswer?.value}
            </div>
          </div>
        ) : null}
        {question.partnerAnswer?.value ? (
          <div className="insight-text-answer-both__input-wrapper">
            <div className="insight-text-answer-both__label">
              {t("insight_questionnaire_form_page.partnerAnswer")}
            </div>
            <div
              placeholder={t("insight_questionnaire_form_page.partnerAnswer")}
            >
              {question.partnerAnswer?.value}
            </div>
          </div>
        ) : null}
      </div>
    </BaseFormBlock>
  );
}
